import { render, staticRenderFns } from "./historicalPlugIn.vue?vue&type=template&id=002ad7d7&scoped=true"
import script from "./historicalPlugIn.vue?vue&type=script&lang=js"
export * from "./historicalPlugIn.vue?vue&type=script&lang=js"
import style0 from "./historicalPlugIn.vue?vue&type=style&index=0&id=002ad7d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ad7d7",
  null
  
)

export default component.exports